import { Directive } from '@angular/core';

@Directive({
  selector: '[appScrollable]'
})
export class ScrollableDirective {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/directives/scrollable.directive.ts